<main class="contacts-page-wrapper page-wrapper">
  <app-general-header title="Contacts" [hideBorder]="true">
    <div class="filters flex gap-2 items-center">
      <app-tab-selector-button [active]="selectedTab() === 'contacts'" (click)="setActiveTab('contacts')"
        >Contacts</app-tab-selector-button
      >
      <app-tab-selector-button [active]="selectedTab() === 'invitations'" (click)="setActiveTab('invitations')"
        >Invitations</app-tab-selector-button
      >
      <app-search-input [verticalSpacing]="false" (searchText)="onSearchChange($event)"></app-search-input>
    </div>
  </app-general-header>

  @if (selectedTab() === 'contacts') {
    <app-contacts-listing class="flex-1 min-h-0"></app-contacts-listing>
  } @else if (selectedTab() === 'invitations') {
    <app-invitations-listing class="flex-1 min-h-0"></app-invitations-listing>
  }
</main>
